import sordAccordion from './athletes/under/sort-accordion'
import flipTurn from './athletes/under/flip-turn'
import pstory from './athletes/under/pstory'
import gradeTable from './athletes/under/grade-table'

(() => {
  sordAccordion();
  flipTurn();
  pstory();
  gradeTable();
})()
